"use strict";

import $ from "jquery";
import scrollToElm from "../../Shared/helpers/helper.scrollToElm";

export default function anchor() {
    // Contact / support

    $("[data-anchor-menu-item]").on("click", function () {
        if (
            $("[data-menu-anchor-id=" + $(this).data("anchorMenuItem") + "]")
                .length
        ) {
            scrollToElm(
                $(
                    "[data-menu-anchor-id=" +
                        $(this).data("anchorMenuItem") +
                        "]",
                ),
                500,
            );
        }

        return false;
    });
}
